function parseDate(dateString) {
    if (dateString == "0001-01-01T00:00:00Z") {
        return ""
    } else if (dateString) {
        var date = new Date(Date.parse(dateString))
        var today = new Date()
        var yesterday = new Date()
        yesterday.setDate(yesterday.getDate() - 1)

        if (date.toDateString() == today.toDateString()) {
            return "今天 " + zeroFill(date.getHours(), 2) + ":" + zeroFill(date.getMinutes(), 2)
        } else if (date.toDateString() == yesterday.toDateString()) {
            return "昨天 " + zeroFill(date.getHours(), 2) + ":" + zeroFill(date.getMinutes(), 2)
        } else {
            return date.getFullYear() + "-" + zeroFill(date.getMonth() + 1, 2) + "-" + zeroFill(date.getDate(), 2) + " " + zeroFill(date.getHours(), 2) + ":" + zeroFill(date.getMinutes(), 2)
        }
    } else {
        return ""
    }
}

function zeroFill( number, width ) {
  width -= number.toString().length;

  if ( width > 0 ) {
    return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number;
  }

  return number + ""; // always return a string
}

export {
    parseDate,
    zeroFill
}
